import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useStyles from './roundPurpleSVG.styles';
/* eslint no-tabs: ['error', { allowIndentationTabs: true }] */

const DEFAULT_ICON_SIZE = 53;
const BUTTON_BASE_WIDTH = 192;

const RoundPurpleSVG = (props) => {
	const classes = useStyles();
	const {
		width,
		text,
        iconSize,
        onTextMatrixChange,
	} = props;
	const textRef = useRef();
	const [transformMatrix, setTransformMatrix] = useState('matrix(1 0 0 1 58.5319 28.4999)');

    useEffect(() => {
        onTextMatrixChange(transformMatrix);
    }, [transformMatrix]);

	useEffect(() => {
		if (textRef.current) {
			const text = textRef.current;
			const tbox = text.getBBox();
            // Note: Always use the iconSize as an offset to center things accordingly
			const newX = (iconSize / 2) + ((BUTTON_BASE_WIDTH - tbox.width) / 2);
			const translation = 'matrix(1 0 0 1 ' + newX + ' 28.4999)'; // will be sent to the backend as textMatrix
			setTransformMatrix(translation);
		}
	}, [textRef.current, width, text]);

	return (
		<svg
            version="1.1"
            id="Layer_1"
            x="0px"
            y="0px"
            viewBox="0 0 202.6 48"
            xmlSpace="preserve"
            xmlnsXlink='http://www.w3.org/1999/xlink'
            >
                <g>
                    <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="202.9975" y1="26" x2="2.463054e-03" y2="26" gradientTransform="matrix(1 0 0 -1 0 50)">
                        <stop offset="0" style={{ stopColor: '#100239' }} />
                        <stop offset="1" style={{ stopColor: '#301256' }} />
                    </linearGradient>
                    <path className={classes.st0} d="M5.5,47.5c-2.8,0-5-2.3-5-5.1V5.6c0-2.8,2.2-5.1,5-5.1h192c2.8,0,5,2.3,5,5.1v36.8c0,2.8-2.2,5.1-5,5.1H5.5z"
                        />
                    {/* <path className={classes.st1} d="M197.5,1c2.5,0,4.5,2.1,4.5,4.6v36.8c0,2.5-2,4.6-4.5,4.6H5.5C3,47,1,44.9,1,42.4V5.6C1,3.1,3,1,5.5,1H197.5
                        M197.5,0H5.5C2.5,0,0,2.5,0,5.6v36.8C0,45.5,2.5,48,5.5,48h192c3,0,5.5-2.5,5.5-5.6V5.6C203,2.5,200.5,0,197.5,0L197.5,0z"/> */}
                </g>

                <text ref={textRef} transform={transformMatrix} className={classNames([classes.st2, classes.st3, classes.st4])} >{text}</text>

                {/* <path className={classes.st5} d="M1,6c0-2.8,2.2-5,5-5h38v46H6c-2.8,0-5-2.2-5-5V6z"/> */}
                <g transform='translate(8 12.5) scale(0.075)'>
                    <defs>
                        <linearGradient id='ecalLoadingGrad1' x1='99.12' y1='54.1' x2='426.64' y2='53.52' gradientUnits='userSpaceOnUse'>
                            <stop offset='0' stopColor='#ff9e00' />
                            <stop offset='1' stopColor='#ff4c00' />
                        </linearGradient>
                        <linearGradient id='ecalLoadingGrad2' x1='-19860.28' y1='54.12' x2='-19497.81' y2='53.48' gradientTransform='translate(11289.25 107.61) scale(0.56 -1)' gradientUnits='userSpaceOnUse'>
                            <stop offset='0' stopColor='#ff9e00' />
                            <stop offset='1' stopColor='#ffe000' />
                        </linearGradient>
                        <linearGradient id='ecalLoadingGrad3' x1='2.65' y1='161.67' x2='290.7' y2='161.16' gradientUnits='userSpaceOnUse'>
                            <stop offset='0' stopColor='#00d7ff' />
                            <stop offset='0.16' stopColor='#00c6ff' />
                            <stop offset='1' stopColor='#0074ff' />
                        </linearGradient>
                        <linearGradient id='ecalLoadingGrad4' x1='51.86' y1='161.42' x2='257.92' y2='161.42' gradientTransform='translate(309.78 322.83) rotate(180)' gradientUnits='userSpaceOnUse'>
                            <stop offset='0' stopColor='#00d6ff' />
                            <stop offset='0.53' stopColor='#00d5a2' />
                            <stop offset='1' stopColor='#00d54f' />
                        </linearGradient>
                        <linearGradient id='ecalLoadingGrad5' x1='44.77' y1='269.3' x2='376.03' y2='268.72' gradientUnits='userSpaceOnUse'>
                            <stop offset='0' stopColor='#000084' />
                            <stop offset='1' stopColor='#0074ff' />
                        </linearGradient>
                        <linearGradient id='ecalLoadingGrad6' x1='132.56' y1='269.01' x2='380.78' y2='269.01' gradientTransform='translate(513.34 538.02) rotate(-180)' gradientUnits='userSpaceOnUse'>
                            <stop offset='0' stopColor='#0074ff' />
                            <stop offset='1' stopColor='#000084' />
                        </linearGradient>
                    </defs>
                    <rect style={{ fill: 'url(#ecalLoadingGrad1)' }} x='96.11' y='0' width='335.23' height='107.61' rx='53.81' ry='53.81' />
                    <rect style={{ fill: 'url(#ecalLoadingGrad2)' }} x='180.23' y='0' width='207.49' height='107.61' rx='53.81' ry='53.81' transform='translate(567.94 107.61) rotate(180)' />
                    <rect style={{ fill: 'url(#ecalLoadingGrad3)' }} x='0' y='107.61' width='294.83' height='107.61' rx='53.81' ry='53.81' />
                    <rect style={{ fill: 'url(#ecalLoadingGrad4)' }} x='51.86' y='107.61' width='206.06' height='107.61' rx='53.81' ry='53.81' transform='translate(309.78 322.83) rotate(-180)' />
                    <rect style={{ fill: 'url(#ecalLoadingGrad5)' }} x='41.72' y='215.2' width='339.05' height='107.61' rx='53.81' ry='53.81' />
                    <rect style={{ fill: 'url(#ecalLoadingGrad6)' }} x='132.56' y='215.2' width='248.22' height='107.61' rx='53.81' ry='53.81' transform='translate(513.34 538.02) rotate(180)' />
                </g>
        </svg>
	);
};

RoundPurpleSVG.propTypes = {
	width: PropTypes.number,
	text: PropTypes.string,
	iconSize: PropTypes.number,
    onTextMatrixChange: PropTypes.func,
};

RoundPurpleSVG.defaultProps = {
	width: 200,
	text: 'Sync to Calendar',
	iconSize: DEFAULT_ICON_SIZE,
    onTextMatrixChange: () => {},
};

export default RoundPurpleSVG;
